
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipWreckFilled as ObiShipWreckFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-wreck-filled.js';
 
 
 

 
 export const ObiShipWreckFilled = createComponent({
   react: React,
   tagName: 'obi-ship-wreck-filled',
   elementClass: ObiShipWreckFilledElement,
   events: {
     
   }
  });
 
 